import { FC } from 'react';
import cn from 'classnames';
import styles from './Icon.module.css';
import { Image } from 'react-bootstrap';

export type IconSize = 'xxs' | 'xs' | 's' | 'sm' | 'md' | 'lg';
export type IconShape = 'rounded' | 'roundedCircle' | 'thumbnail';

interface IconProps {
  imageUrl?: string;
  size?: IconSize;
  shape?: IconShape;
  alt?: string;
  title?: string;
  color?: string;
}

const Icon: FC<IconProps> = ({
  imageUrl,
  size = 'md',
  shape = 'rounded',
  alt = 'Logo',
  title = '',
  color,
}) => {
  const commonProps = {
    title,
    className: cn(styles[`icon-${size}`]),
    rounded: shape === 'rounded',
    roundedCircle: shape === 'roundedCircle',
    thumbnail: shape === 'thumbnail',
  };

  return color ? (
    <Image {...commonProps} style={{ backgroundColor: color }} />
  ) : (
    <Image {...commonProps} src={imageUrl} alt={alt} />
  );
};

export default Icon;
